/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue/dist/vue.esm.js';
import axios         from 'axios';
import bus           from '../../bus.js';
import BeatsList     from '@/components/BeatsList.vue';
import PageBanner    from '@/components/PageBanner.vue';
import FullWidthCta  from '@/components/FullWidthCta.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);
library.add(faCaretDown);
library.add(faChevronDown);	
Vue.component('font-awesome-icon', FontAwesomeIcon)

const __vue_script__ = {
	data() {
		return {
			products: [],
			audioSources: [],
			categories: [],
			genres: [],
			filter: [],
			bannerimage: '',
			bannerHeader: '',
			bannerParagraph: ui_data['beatsPageBannerParagraph'],
			showAllFilters: false,
			catDropdownExpanded: false,
			genreDropdownExpanded: false,
			bpmDropdownExpanded: false,
			moodDropdownExpanded: false,
			offset: 0,
			showLoadMoreBtn: true,
			bpms: [],
			moods: [],
			loadingState: true,
			bannerH1Class: '',
		}
	},
	props: {
		genre: String,
		mood: String,
		tag: String,
	},
	components: {
		PageBanner,
		BeatsList,
		FullWidthCta
	},
	computed: {
		filterToggleButtonText: function () {
			return this.showAllFilters ? 'Hide Filters' : 'Show Filters';
		},
		filterItems() {
			let combined = this.genres.concat(this.categories);
			combined = combined.concat(this.bpms);
			combined = combined.concat(this.moods);
		
			return combined.filter(a => {
				if (a.isActive === true) {
					return true;
				}
			});
			
		},
		filterCats() {
			return this.categories.filter(a => {
				if (a.isActive === true) {
					return true;
				}
			});
		},
		filterGenres() {
			return this.genres.filter(a => {
				if (a.isActive === true) {
					return true;
				}
			});
		},
		filterBPMS() {
			return this.bpms.filter(a => {
				if (a.isActive === true) {
					return true;
				}
			});
		},
		filterMoods() {
			return this.moods.filter(a => {
				if (a.isActive === true) {
					return true;
				}
			});
		},
	},
	methods: {
		toggleAllFilters() {
			this.showAllFilters = !this.showAllFilters;
		},
		toggleCatDropDown() {
			this.catDropdownExpanded = !this.catDropdownExpanded;
		},
		toggleGenreDropDown() {
			this.genreDropdownExpanded = !this.genreDropdownExpanded;
		},
		toggleBPMDropDown() {
			this.bpmDropdownExpanded = !this.bpmDropdownExpanded;
		},
		toggleMoodDropDown() {
			this.moodDropdownExpanded = !this.moodDropdownExpanded;
		},
		hideCatDropDown() {
			this.catDropdownExpanded = false;
		},
		hideGenreDropDown() {
			this.genreDropdownExpanded = false;
		},
		hideBPMDropDown() {
			this.bpmDropdownExpanded = false;
		},
		hideMoodDropdown() {
			this.moodDropdownExpanded = false;
		},
		catHandler( category ) {
			this.toggleCatDropDown();
			this.categories.forEach(category => {
				category.isActive = false;
			});
			category.isActive = !category.isActive;
			this.runFilterQuery();
		},
		genreHandler( genre, ui = true ) {
			if (ui) {
				this.toggleGenreDropDown();
			}
		
			this.genres.forEach(genre => {
				genre.isActive = false;
			});
			genre.isActive = !genre.isActive;
			
			this.runFilterQuery();
		},
		bpmHandler( bpm ) {
			this.toggleBPMDropDown();
			this.bpms.forEach(bpm => {
				bpm.isActive = false;
			});
			bpm.isActive = !bpm.isActive;
			this.runFilterQuery();
		},
		moodHandler( mood, ui = true ) {
			if ( ui ) {
				this.toggleMoodDropDown();
			}
			this.moods.forEach(mood => {
				mood.isActive = false;
			});
			mood.isActive = !mood.isActive;
			this.runFilterQuery();
		},
		resetGenres() {
			this.genres.forEach(genre => {
				genre.isActive = false;
			});
			this.toggleGenreDropDown();
			this.runFilterQuery();
		},
		resetCategories() {
			this.categories.forEach(category => {
				category.isActive = false;
			});
			this.toggleCatDropDown();
			this.runFilterQuery();
		},
		
		resetBPMs() {
			this.bpms.forEach(bpm => {
				bpm.isActive = false;
			});
			this.toggleBPMDropDown();
			this.runFilterQuery();
		},
		resetMoods() {
			this.moods.forEach(mood => {
				mood.isActive = false;
			});
			this.toggleMoodDropDown();
			this.runFilterQuery();
		},
		runFilterQuery() {
			let vm = this;
			vm.loadingState = true;
			this.showLoadMoreBtn = false;

			let params = new URLSearchParams();
			this.filterItems.forEach((item, index) => {
				
				if (item.taxonomy == 'beatstore_genre') {
					params.append('beatstore_genre', item.slug);
				} else if (item.taxonomy == 'download_category') {
					params.append('download_category', item.slug);
				} else if ( item.taxonomy == 'beatstore_mood' ) {
					params.append('beatstore_mood', item.slug);
				}
				
				if (item.field == 'bpm') {
					params.append('bpm_min', item.min);
					params.append('bpm_max', item.max);
				}
			});
			if (this.tag) {
				params.append('tag', this.tag);
			}
			let queryString = params.toString();

			axios.get( ui_data.homeUrl  + '/wp-json/beatstore/v1/filter/?' + queryString )
				.then(response => {
					let beats = response.data;
					let i = 0;
					beats.forEach( function( track, index ) {
						//Add index to beats
						track['index'] = i;
						track.visible = true;
						i++;
					});
					vm.products = beats;
					bus.$emit('beatsOnDeck', beats);
					vm.loadingState = false;
				})
		},
		async showAllBeats( offset, push ) {
			return axios.get( ui_data.homeUrl  + '/wp-json/beatstore/v1/beats/subsite/offset/' + offset )
		},
		async loadMoreBeats() {
			let vm = this;
			this.offset += 40;
			let response = await this.showAllBeats( this.offset, true );
			if ( response.data === undefined || response.data.length == 0 ) {
				this.showLoadMoreBtn = false;

				return;
			} else {
				this.showLoadMoreBtn = true;
			}

			let beats = response.data;
			let i = this.offset;
			beats.forEach( function( track, index ) {
				if ( track.exclude === 'false' ) {
					track['index'] = i;
					track.visible = true;	
				} else {
					track.visible = false;
					track['index'] = i;
					vm.products.splice(i,1);
				}
				i++;
			});

			let combined = this.products.concat(beats);
			this.products = combined;
			bus.$emit('beatsOnDeck', combined);
			vm.loadingState = false;
		},
		async setupFilters() {
			try {
				const [bpmResponse, genreResponse, catResponse, moodResponse] = await Promise.all([
					axios.get(ui_data.homeUrl + '/wp-json/beatstore/v1/bpm_range'),
					axios.get(ui_data.homeUrl + '/wp-json/beatstore/v1/genres'),
					axios.get(ui_data.homeUrl + '/wp-json/beatstore/v1/categories'),
					axios.get(ui_data.homeUrl + '/wp-json/beatstore/v1/moods')
				]);

				this.bpms = bpmResponse.data;
				this.genres = genreResponse.data;
				this.categories = catResponse.data;
				this.moods = moodResponse.data;
			} catch (error) {
				// Handle errors if any of the requests fail
				console.error(error);
			}
		},
	},
	async mounted() {
		this.ctaHeadline  = ui_data.ctaHeadline;
		this.ctaParagraph = ui_data.ctaParagraph;
		this.ctaButton    = ui_data.ctaButton;
		this.ctaLink      = ui_data.ctaLink;
		this.bannerimage  = ui_data.beatsPageBannerImage;
		await this.setupFilters();

		if ( this.genre ) {
			const foundGenre = this.genres.find((item) => item.slug === this.genre);

			if ( foundGenre ) {
				this.genreHandler( foundGenre, false );
				this.bannerHeader = ` ${foundGenre.name} Beats`;
				this.bannerH1Class = 'dynamic-genre';
				this.bannerParagraph = foundGenre.description;
			}
			return;
		} else if ( this.mood ) {
			const foundMood = this.moods.find((item) => item.slug === this.mood);

			if ( foundMood ) {
				this.moodHandler( foundMood, false );
				this.bannerHeader = ` ${foundMood.name} Beats`;
				this.bannerH1Class = 'dynamic-genre';
				this.bannerParagraph = foundMood.description;
			}
			return;
		} else if ( this.tag ) {
			// console.log('tag detected', this.tag);
			this.bannerH1Class = 'dynamic-genre';
			this.bannerHeader = `#${this.tag} Beats`;
			this.bannerParagraph = this.tag.description;
			this.runFilterQuery();
			return;
		} else {
			this.bannerHeader = ui_data.beatsPageBannerText;
		}

		let response = await this.showAllBeats( 0, false );
		if ( response.data === undefined || response.data.length == 0 ) {
			this.showLoadMoreBtn = false;
		} else {
			this.showLoadMoreBtn = true;
		}

		let vm = this;
		let beats = response.data;
		let i = 0;

		beats.forEach( function( track, index ) {
			if ( track.exclude === 'false' ) {
				track['index'] = i;
				track.visible = true;
				i++;
				
			} else {
				track.visible = false;
				track['index'] = i;
				vm.products.splice(i,1);
				i++;
			}
		});		
		vm.products = beats;
		bus.$emit('beatsOnDeck', vm.products );
		vm.loadingState = false;
	},
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all-beats-page"},[_c('PageBanner',{attrs:{"imageSource":_vm.bannerimage,"bannerHeader":_vm.bannerHeader,"bannerParagraph":_vm.bannerParagraph,"smallBanner":true,"className":_vm.bannerH1Class}}),_vm._v(" "),_c('div',{staticClass:"container flex"},[_c('div',{staticClass:"genre-filter"},[_c('h2',[_vm._v("Filter")]),_vm._v(" "),_c('button',{staticClass:"toggle-all-filters-btn",attrs:{"aria-label":"Toggle All Filters","aria-expanded":_vm.showAllFilters},on:{"click":_vm.toggleAllFilters}},[_c('span',[_vm._v(_vm._s(_vm.filterToggleButtonText))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-down']}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAllFilters),expression:"showAllFilters"}],staticClass:"all-filters-wrapper"},[(_vm.genres.length)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideGenreDropDown),expression:"hideGenreDropDown"}],staticClass:"filter-header"},[_c('label',[_vm._v("Genre")]),_vm._v(" "),_c('button',{staticClass:"filter-dropdown",attrs:{"aria-label":"Toggle Dropdown","aria-expanded":_vm.genreDropdownExpanded},on:{"click":_vm.toggleGenreDropDown}},[_vm._l((_vm.filterGenres),function(item){return _c('span',[_vm._v(_vm._s(item.name))])}),_vm._v(" "),(_vm.filterGenres.length < 1)?_c('span',[_vm._v("All")]):_vm._e(),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'caret-down']}})],2),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","width":"100%"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.genreDropdownExpanded),expression:"genreDropdownExpanded"}]},[_c('li',{class:{active: _vm.filterGenres.length < 1}},[_c('button',{on:{"click":_vm.resetGenres}},[_vm._v("All")])]),_vm._v(" "),_vm._l((_vm.genres),function(genre){return _c('li',{class:{active: genre.isActive}},[_c('button',{on:{"click":function($event){return _vm.genreHandler(genre)}}},[_vm._v(_vm._s(genre.name))])])})],2)])]):_vm._e(),_vm._v(" "),(_vm.bpms.length)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideBPMDropDown),expression:"hideBPMDropDown"}],staticClass:"filter-header"},[_c('label',[_vm._v("BPM")]),_vm._v(" "),_c('button',{staticClass:"filter-dropdown",attrs:{"aria-label":"Toggle Dropdown","aria-expanded":_vm.bpmDropdownExpanded},on:{"click":_vm.toggleBPMDropDown}},[_vm._l((_vm.filterBPMS),function(item){return _c('span',[_vm._v(_vm._s(item.name))])}),_vm._v(" "),(_vm.filterBPMS.length < 1)?_c('span',[_vm._v("All")]):_vm._e(),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'caret-down']}})],2),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","width":"100%"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.bpmDropdownExpanded),expression:"bpmDropdownExpanded"}]},[_c('li',{class:{active: _vm.filterBPMS.length < 1}},[_c('button',{on:{"click":_vm.resetBPMs}},[_vm._v("All")])]),_vm._v(" "),_vm._l((_vm.bpms),function(bpm){return _c('li',{class:{active: bpm.isActive}},[_c('button',{on:{"click":function($event){return _vm.bpmHandler(bpm)}}},[_vm._v(_vm._s(bpm.name))])])})],2)])]):_vm._e(),_vm._v(" "),(_vm.categories.length)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideCatDropDown),expression:"hideCatDropDown"}],staticClass:"filter-header"},[_c('label',[_vm._v("Category")]),_vm._v(" "),_c('button',{staticClass:"filter-dropdown",attrs:{"aria-label":"Toggle Dropdown","aria-expanded":_vm.catDropdownExpanded},on:{"click":_vm.toggleCatDropDown}},[_vm._l((_vm.filterCats),function(item){return _c('span',[_vm._v(_vm._s(item.name))])}),_vm._v(" "),(_vm.filterCats.length < 1)?_c('span',[_vm._v("All")]):_vm._e(),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'caret-down']}})],2),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","width":"100%"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.catDropdownExpanded),expression:"catDropdownExpanded"}]},[_c('li',{class:{active: _vm.filterCats.length < 1}},[_c('button',{on:{"click":_vm.resetCategories}},[_vm._v("All")])]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('li',{class:{active: category.isActive}},[_c('button',{on:{"click":function($event){return _vm.catHandler(category)}}},[_vm._v(_vm._s(category.name))])])})],2)])]):_vm._e(),_vm._v(" "),(_vm.moods.length)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideMoodDropdown),expression:"hideMoodDropdown"}],staticClass:"filter-header"},[_c('label',[_vm._v("Mood")]),_vm._v(" "),_c('button',{staticClass:"filter-dropdown",attrs:{"aria-label":"Toggle Dropdown","aria-expanded":_vm.moodDropdownExpanded},on:{"click":_vm.toggleMoodDropDown}},[_vm._l((_vm.filterMoods),function(item){return _c('span',[_vm._v(_vm._s(item.name))])}),_vm._v(" "),(_vm.filterMoods.length < 1)?_c('span',[_vm._v("All")]):_vm._e(),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'caret-down']}})],2),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","width":"100%"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.moodDropdownExpanded),expression:"moodDropdownExpanded"}]},[_c('li',{class:{active: _vm.filterMoods.length < 1}},[_c('button',{on:{"click":_vm.resetMoods}},[_vm._v("All")])]),_vm._v(" "),_vm._l((_vm.moods),function(mood){return _c('li',{class:{active: mood.isActive}},[_c('button',{on:{"click":function($event){return _vm.moodHandler(mood)}}},[_vm._v(_vm._s(mood.name))])])})],2)])]):_vm._e()])]),_vm._v(" "),_c('BeatsList',{attrs:{"loading":_vm.loadingState,"products":_vm.products}})],1),_vm._v(" "),(_vm.showLoadMoreBtn)?_c('div',{staticClass:"load-more-beats"},[_c('button',{staticClass:"btn load-more-btn",on:{"click":function($event){return _vm.loadMoreBeats()}}},[_vm._v("Load More")])]):_vm._e()],1),_vm._v(" "),_c('FullWidthCta',{attrs:{"ctaHeadline":_vm.ctaHeadline,"ctaParagraph":_vm.ctaParagraph,"ctaButton":_vm.ctaButton,"ctaLink":_vm.ctaLink}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AllBeatsPage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__